




import { Vue, Component, Prop } from 'nuxt-property-decorator';
import HeaderGuest from './HeaderGuest.vue';
import HeaderOutsider from './HeaderOutsider.vue';
import HeaderMember from './HeaderMember.vue';
import HeaderLanding from './HeaderLanding.vue';
import { isWarRoomUser } from '~/components/partials/war-room/utils';
import { SKIP_ONBOARDING_NAME } from '~/components/partials/war-room/WarRoomSignUp/skipOnboarding';

@Component
export default class Header extends Vue {
  @Prop({ default: false }) showOnMobile!: boolean;
  @Prop({ default: true }) withNavbar!: boolean;
  @Prop({ default: true }) sticky!: boolean;

  get headerComponent() {
    const withSkippedOnboarding = this.$cookies.get(SKIP_ONBOARDING_NAME);
    const isLandingPage = this.$route.path === '/';

    // FIXME [Performance] find a way to load headers asyncronycally
    // FIXME [reafactoring] use 1-2 header with conditions inside
    if (!this.$auth.loggedIn && isLandingPage) return HeaderLanding;
    if (!this.$auth.loggedIn) return HeaderGuest;
    if (!isWarRoomUser(this.$auth.user) && !withSkippedOnboarding) return HeaderOutsider;

    return HeaderMember;
  }

  get rootClass() {
    return {
      header: true,
      'header--sticky': this.sticky,
    };
  }
}
